import React from "react";
import Welcome from "../master_pobox";
import apiUrl from "../enviroments/enviroment";
import axios from 'axios';
import {Button, Form} from "react-bootstrap";
import { DateTime } from "luxon";
import swal from "sweetalert";
import Table from 'react-bootstrap/Table';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

class EstadoCuentaBusiness extends React.Component{

    state = {
        EstadoCuentaBusiness: [],
        TxtFechaInicial: '',
        TxtFechaFinal: '',
        TipoConsulta: '1',
        currentPage: 1,
        itemsPerPage: 10,
        TxtAbonos: '',
        TxtCargos: '',
        TxtSaldoini: '',
        TxtSaldoFin: '',
        TxtFechadisp: '',
        TxtFecha_fin: ''
    };

    change = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handlePageChange = (page) => {
        this.setState({ currentPage: page });
    };

    getPaginatedData = () => {
        const { EstadoCuentaBusiness, currentPage, itemsPerPage } = this.state;
        const startIndex = (currentPage - 1) * itemsPerPage;
        return EstadoCuentaBusiness.slice(startIndex, startIndex + itemsPerPage);
    };

    onSubmit = (e) => {
        e.preventDefault();

        const { TxtFechaInicial, TxtFechaFinal, TipoConsulta } = this.state;
        const Seccion = localStorage.getItem('seccion');

        // Validación 1: campos vacíos
        if (!TxtFechaInicial || !TxtFechaFinal) {
            swal("Advertencia", "Debe seleccionar ambas fechas.", "warning");
            return;
        }

        // Convertimos fechas para comparación
        const fechaIni = DateTime.fromISO(TxtFechaInicial);
        const fechaFin = DateTime.fromISO(TxtFechaFinal);

        // Validación 2: formato válido
        if (!fechaIni.isValid || !fechaFin.isValid) {
            swal("Error", "Las fechas seleccionadas no son válidas.", "error");
            return;
        }

        // Validación 3: fecha inicial > fecha final
        if (fechaIni > fechaFin) {
            swal("Advertencia", "La fecha inicial no puede ser mayor que la fecha final.", "warning");
            return;
        }

        // Convertir formato a dd-MM-yyyy
        const newStartDate = fechaIni.toFormat("dd-MM-yyyy");
        const newFinishDate = fechaFin.toFormat("dd-MM-yyyy");

        this.peticion(Seccion, newStartDate, newFinishDate, TipoConsulta);
    };


    peticion(seccion, fchin, fchfn, tipo){
        axios.get(`${apiUrl.apiUrl}estadoCuentaBusiness/${seccion}/${fchin}/${fchfn}/${tipo}`, {
            headers: {
                userid: 'transexpress',
                pwduser: 'JTOYV9IlFarK6G2jPRo7dJxkmfHOhD9S',
            }
        }).then(res => {
            this.setState({EstadoCuentaBusiness: res.data});
            //console.log();
            this.setState({
                TxtAbonos: this.state.EstadoCuentaBusiness[0]?.tot_abono || '',
                TxtCargos: this.state.EstadoCuentaBusiness[0]?.tot_cargo || '',
                TxtSaldoini: this.state.EstadoCuentaBusiness[0]?.saldo_disponible || '',
                TxtSaldoFin: this.state.EstadoCuentaBusiness[0]?.tot_saldo || '',
                TxtFecha_fin: this.state.EstadoCuentaBusiness[0]?.fecha_fin || '',
                TxtFechadisp: this.state.EstadoCuentaBusiness[0]?.fecha_disp || ''
            });
            swal("Éxito", "Consulta realizada con éxito", "success");
        },(error) => {
            console.log(error);
            swal("Ayuda", "Ha ocurrido un error, contactate con el administrador del sitio web", "error");
        });
    }

    /* ========== EXPORTAR A EXCEL ========== */
    exportToExcel = () => {
        const { EstadoCuentaBusiness } = this.state;

        if (EstadoCuentaBusiness.length === 0) {
            swal("Advertencia", "No hay datos para exportar.", "warning");
            return;
        }

        // Orden y títulos de columnas
        const data = EstadoCuentaBusiness.map(item => ({
            "Fecha": item.fecha,
            "TP": item.tipo_documento,
            "Sección": item.seccion,
            "Número": item.no_documento,
            "Tasa": item.tasa,
            "Cargo": item.cargo,
            "Abono": item.abono,
            "Peso": item.peso,
            "Detalle": item.concepto,
            "Valor": item.valor
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();

        // Auto-width (ancho automático de columnas)
        const columnWidths = Object.keys(data[0]).map((col) => {
            const maxLength = data.reduce((max, row) => {
                return Math.max(max, row[col]?.toString().length || 0);
            }, col.length);

            return { wch: maxLength + 3 };
        });

        worksheet['!cols'] = columnWidths;

        XLSX.utils.book_append_sheet(workbook, worksheet, "EstadoCuenta");
        XLSX.writeFile(workbook, "EstadoCuentaBusiness.xlsx");
    };

    /* ========== EXPORTAR A PDF ========== */
    exportToPDF = () => {
        const { EstadoCuentaBusiness } = this.state;

        if (EstadoCuentaBusiness.length === 0) {
            swal("Advertencia", "No hay datos para exportar.", "warning");
            return;
        }

        const doc = new jsPDF({ orientation: "landscape" });
        doc.setFontSize(14);
        doc.text("Estado de Cuenta Business", 14, 15);

        const columns = ["Fecha", "TP", "Sección", "Número", "Tasa", "Cargo", "Abono", "Peso", "Detalle", "Valor"];

        const rows = EstadoCuentaBusiness.map(item => [
            item.fecha,
            item.tipo_documento,
            item.seccion,
            item.no_documento,
            item.tasa,
            item.cargo,
            item.abono,
            item.peso,
            item.concepto,
            item.valor
        ]);

        doc.autoTable({
            head: [columns],
            body: rows,
            startY: 25,
            styles: { fontSize: 8 }
        });

        doc.save("EstadoCuentaBusiness.pdf");
    };

    getColorClass = (value, type = "") => {
        if (type === "cargo") return "text-danger";      // rojo
        if (type === "abono") return "text-success";     // verde

        // Saldo disponible: depende del valor
        const val = parseFloat(value);
        if (isNaN(val)) return ""; // sin estilo si no es número

        return val >= 0 ? "text-success" : "text-danger";
    };

    formatCurrency = (value) => {
        if (!value) return "Q 0.00";

        return new Intl.NumberFormat("es-GT", {
            style: "currency",
            currency: "GTQ",
            minimumFractionDigits: 2
        }).format(value);
    };


    render(){
        return (
            <Welcome>


                <main id="js-page-content" role="main" className="page-content">
                    <div className="subheader" >
                        <h1 className="subheader-block"  >
                            <i className="fal fa-info-circle"/>
                            <label className="label letras">
                                ESTADO DE CUENTA BUSINESS
                            </label>
                        </h1>
                    </div>
                    <div className="fs-lg fw-300 p-5 bg-white border-faded rounded mb-g">
                        <div className="col-sm-12 row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row align-items-end">

                                            <div className="col-sm-2 text-center">
                                                <label className="label other">
                                                    <i className="fal fa-file-invoice fa-6x" />
                                                </label>
                                            </div>

                                            <div className="col-sm-3">
                                                <label className="form-label">Fecha Inicial:</label>
                                                <Form.Control
                                                    value={this.state.TxtFechaInicial}
                                                    className="form-control form-control-lg"
                                                    type="date"
                                                    name="TxtFechaInicial"
                                                    onChange={this.change}
                                                />
                                            </div>

                                            <div className="col-sm-3">
                                                <label className="form-label">Fecha Final:</label>
                                                <Form.Control
                                                    value={this.state.TxtFechaFinal}
                                                    className="form-control form-control-lg"
                                                    type="date"
                                                    name="TxtFechaFinal"
                                                    onChange={this.change}
                                                />
                                            </div>

                                            <div className="col-sm-3">
                                                <label className="form-label d-block">Tipo:</label>
                                                    <Form.Check
                                                        inline
                                                        label="Individual"
                                                        name="TipoConsulta"
                                                        type="radio"
                                                        id="radio-individual"
                                                        value="1"
                                                        checked={this.state.TipoConsulta === "1"}
                                                        onChange={this.change}
                                                    />

                                                    <Form.Check
                                                        inline
                                                        label="Consolidado"
                                                        name="TipoConsulta"
                                                        type="radio"
                                                        id="radio-consolidado"
                                                        value="2"
                                                        checked={this.state.TipoConsulta === "2"}
                                                        onChange={this.change}
                                                    />
                                            </div>

                                            <div className="col-sm-1 text-end">
                                                <Button
                                                    className="btn btn-primary mt-4"
                                                    onClick={this.onSubmit}
                                                >
                                                    Buscar
                                                </Button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <br/>
                        <br/>

                        <div className="d-flex justify-content-end mb-3 gap-2">
                            <Button variant="success" onClick={this.exportToExcel}>
                                Exportar a Excel
                            </Button>

                            <Button variant="danger" onClick={this.exportToPDF}>
                                Exportar a PDF
                            </Button>
                        </div>

                        <Table responsive striped bordered hover size="sm">
                            <thead >
                                <tr class="bg-primary text-white">
                                    <th>Fecha</th>
                                    <th>TP</th>
                                    <th>Sección</th>
                                    <th>Número</th>
                                    <th>Tasa</th>
                                    <th>Cargos</th>
                                    <th>Abonos</th>
                                    <th>Peso</th>
                                    <th>Detalle</th>
                                    <th>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.getPaginatedData().map((gen, idx) =>
                                    <tr>
                                        <td>{gen.fecha.substring(0, 10)}</td>
                                        <td>{gen.tipo_documento}</td>
                                        <td>{gen.seccion}</td>
                                        <td>{gen.no_documento}</td>
                                        <td>{gen.tasa}</td>
                                        <td>{gen.cargo}</td>
                                        <td>{gen.abono}</td>
                                        <td>{gen.peso}</td>
                                        <td>{gen.concepto}</td>
                                        <td>{gen.valor}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        {/* PAGINACIÓN */}
                        <div className="d-flex justify-content-center mt-3">
                            <nav>
                                <ul className="pagination">

                                    {/* Botón anterior */}
                                    <li className={`page-item ${this.state.currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => this.handlePageChange(this.state.currentPage - 1)}
                                        >
                                            Anterior
                                        </button>
                                    </li>

                                    {/* Botones numéricos */}
                                    {Array.from(
                                        { length: Math.ceil(this.state.EstadoCuentaBusiness.length / this.state.itemsPerPage) },
                                        (_, i) => (
                                            <li
                                                key={i}
                                                className={`page-item ${this.state.currentPage === i + 1 ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => this.handlePageChange(i + 1)}
                                                >
                                                    {i + 1}
                                                </button>
                                            </li>
                                        )
                                    )}

                                    {/* Botón siguiente */}
                                    <li
                                        className={`page-item ${
                                            this.state.currentPage === Math.ceil(this.state.EstadoCuentaBusiness.length / this.state.itemsPerPage)
                                                ? "disabled"
                                                : ""
                                        }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => this.handlePageChange(this.state.currentPage + 1)}
                                        >
                                            Siguiente
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        {/* PAGINACIÓN FIN*/}

                        <div className="row mt-4">

                            <div className="col-sm-3">
                                <label>
                                    <strong>Saldo Disponible {this.state.TxtFechadisp?.substring(0, 10)}:</strong>
                                </label>
                                <div className={`form-control ${this.getColorClass(this.state.TxtSaldoini)}`}>
                                    {this.formatCurrency(this.state.TxtSaldoini)}
                                </div>
                            </div>

                            <div className="col-sm-3">
                                <label><strong>Total Cargos:</strong></label>
                                <div className={`form-control ${this.getColorClass(this.state.TxtCargos, "cargo")}`}>
                                    {this.formatCurrency(this.state.TxtCargos)}
                                </div>
                            </div>

                            <div className="col-sm-3">
                                <label><strong>Total Abonos:</strong></label>
                                <div className={`form-control ${this.getColorClass(this.state.TxtAbonos, "abono")}`}>
                                    {this.formatCurrency(this.state.TxtAbonos)}
                                </div>
                            </div>

                            <div className="col-sm-3">
                                <label>
                                    <strong>Saldo Disponible {this.state.TxtFecha_fin?.substring(0, 10)}:</strong>
                                </label>
                                <div className={`form-control ${this.getColorClass(this.state.TxtSaldoFin)}`}>
                                    {this.formatCurrency(this.state.TxtSaldoFin)}
                                </div>
                            </div>

                        </div>

                    </div>
                </main>
            </Welcome>
        )
    }
}
export default EstadoCuentaBusiness;